<template>
  <form>
    <div class="p-mypage_search__content">
        <a v-if="isSubmit" href="javascript:void(0);" class="p-mypage_search__content__reset" @click="reset()">
          <span><img src="/images/pc/reset.png" alt=""></span>
          <span>リセットする</span>
        </a>
        <p class="p-mypage_search__content__title bold">{{ title }}</p>
        <div class="p-mypage_search__content__detail">
          <p v-if="isEmpty">まだ登録されていません。</p>
          <span v-for="(value, index) in form.params.tags" v-bind:key="index" v-if="itemList[value]">{{itemList[value].label}}</span>
        </div>
        <div class="p-mypage_search__content__check slide_detail_open">
          <label class="check__detail" v-for="(item, index) in items" v-bind:key="index">
            <input type="checkbox" name="tags[]" :value="item.value" v-model="form.params.tags">
            <span>{{ item.label }}</span>
          </label>
        </div>
        <button class="p-mypage_search__content__btn slide_open" type="button" @click="submit()">条件追加・変更</button>
    </div>
  </form>
</template>

<script>
import Form from "@/utils/Form";

export default {
  props: {
    items: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    title: String,
    selected : {
      type: Array | null,
      default: null,
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
  },
  data() {
    return {
      form: new Form({
        tags: this.selected
      }),
      itemList: [],
      isSubmit: false,
      isSuccess: false
    }
  },
  methods: {
    submit () {
      if (this.isSubmit == false) {
        this.isSubmit = true;
        return;
      }

      this.form
          .post({
            url: "/mypage/skill/store/",
          })
          .then(({}) => {
            flash('更新しました。おすすめの案件はリロード後に反映されます。', 'success')
            window.scrollTo(0, 0)
            //location.reload()
          })
          .catch((error) => {
            flash('更新に失敗しました。再ログインしもう一度やり直してください。', 'error')
            window.scrollTo(0, 0)
          });
    },

    reset() {
      this.form.params.tags = []
    },

    setList() {
      _.each(this.items, (item, key) => {
        this.itemList[item.value] = item;
      });
    },
  },
  mounted() {
  },
  computed: {
    isEmpty: function () {
      let isEm = true;
      _.each(this.items, (item, key) => {
        if (this.form.params.tags && this.form.params.tags.includes(item.value)) {
          return isEm = false;
        }
      });
      return isEm;
    }
  },
  created() {
    this.setList();
  },
}
</script>
